import { Fragment } from 'react';
import { ProductDocument } from 'models/product';
import { PlaceABidForm } from 'features/auctions/forms/PlaceABidForm';
import MobileDrawer from '../../../components/drawers/MobileDrawer';

type MobilePlaceABidModalProps = {
  show: boolean;
  dismiss: () => void;
  product: ProductDocument;
};

export default function MobilePlaceABidModal({
  show,
  dismiss,
  product,
}: MobilePlaceABidModalProps) {
  return (
    <MobileDrawer show={show} dismiss={dismiss} title="Place a Bid" fullScreen>
      <PlaceABidForm product={product} onSubmitSuccess={dismiss} />
    </MobileDrawer>
  );
}
